import { openOverlay } from '../actions/Overlay';
import { MiniCoachmarkTypes } from '../constants/MiniCoachmark';
import { OVERLAY_ACTIONS, OVERLAY_CONFIG, OVERLAY_TYPES } from '../constants/Overlay';

export function closeMiniCoachmark(miniCoachmarkType, uid) {
  return {
    type: OVERLAY_ACTIONS.CLOSE_OVERLAY,
    overlayConfig: {
      [OVERLAY_CONFIG.SUBTYPE]: miniCoachmarkType,
      [OVERLAY_CONFIG.TYPE]: OVERLAY_TYPES.anchored,
      [OVERLAY_CONFIG.PROPS]: {
        uid,
      },
    },
  };
}

export function buildMiniCoachmarkOverlayConfig(miniCoachmarkType, uid) {
  return {
    [OVERLAY_CONFIG.TYPE]: OVERLAY_TYPES.anchored,
    [OVERLAY_CONFIG.SUBTYPE]: miniCoachmarkType,
    [OVERLAY_CONFIG.PROPS]: {
      uid,
    },
  };
}

export function openMiniCoachmark(miniCoachmarkType, uid) {
  return openOverlay(buildMiniCoachmarkOverlayConfig(miniCoachmarkType, uid));
}

export function openBingeSkipperCoachmark() {
  return openMiniCoachmark(MiniCoachmarkTypes.BINGE_SKIPPER);
}

export function hidePodcastCollectionsCoachmark(isUnmount) {
  return {
    type: OVERLAY_ACTIONS.HIDE_PODCAST_COLLECTIONS_COACHMARK,
    data: {
      isUnmount,
    },
  };
}

export function coachmarkClicked(coachmarkType, reason) {
  return {
    type: OVERLAY_ACTIONS.COACHMARK_CLICKED,
    data: {
      coachmarkType,
      reason,
    },
  };
}
